import { createAction } from 'redux-actions';
import types from '../types';

/**
 * Redux action to acknowledge the event in the eventlist
 * @param {string} payload.assetId assetId
 * @param {string} payload.eventId eventId
 */
export const toggleSelectedEvent = createAction(types.TOGGLE_SELECTED_EVENT);
